<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-with-heading" id="epigraph">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">ABOUT THE AUTHOR</h1>
</div>
</div>
</div>
</div>
<div class="text" id="epigraph-text">
<p class="first first-in-chapter first-full-width epigraph-content">Kate Dane writes quirky stories, often with romance and magic, always with hope. Eric Flint published her first novel, a werewolf romance entitled <i>Sit. Stay. Kill. </i>This is her first alternate history story.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// about-the-author.vue?5a0ca048